import React from "react";
import { Gem, Crosshair, Zap, MapPin, Building2, Tag } from "lucide-react";
import { WHY } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

const ICONS = [Gem, Crosshair, Zap, MapPin, Building2, Tag];

export const WhyChoose = () => (
  <section className="relative border-y border-line bg-ink-800/40">
    <div className="mx-auto max-w-7xl px-5 md:px-8 py-24 md:py-32">
      <Reveal>
        <SectionHeading overline="Why Choose AUS/SIGNS" title="Commercial Signage, Done Right" />
      </Reveal>
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-line border border-line">
        {WHY.map((w, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={w.title} delay={i * 0.06}>
              <div
                data-testid={`why-${i}`}
                className="group h-full bg-ink-900 p-8 hover:bg-ink-800 transition-colors"
              >
                <div className="h-12 w-12 flex items-center justify-center border border-line group-hover:border-orange group-hover:bg-orange transition-colors">
                  <Icon size={22} className="text-orange group-hover:text-white transition-colors" />
                </div>
                <h3 className="mt-5 font-head font-extrabold uppercase text-lg tracking-tight">{w.title}</h3>
                <p className="mt-2 text-white/55 text-sm leading-relaxed">{w.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
